module.exports = __webpack_public_path__ + "static/media/install-1.684ff329.png";